<template>
  <div class="navbar-container-b2b d-flex align-items-center">
    <div class="navbar-zone navbar-zone-left">
      <b-link class="nav-link menu-toggle-btn d-xl-none" @click="toggleVerticalMenuActive">
        <feather-icon icon="MenuIcon" size="18" />
      </b-link>
      <b-link
        class="nav-link menu-collapse-btn d-none d-xl-flex"
        @click="toggleMenuCollapsed"
        v-b-tooltip.hover.bottom="isMenuCollapsed ? 'Expandir Menu' : 'Recolher Menu'"
      >
        <feather-icon :icon="isMenuCollapsed ? 'ChevronsRightIcon' : 'ChevronsLeftIcon'" size="16" />
      </b-link>
    </div>

    <div class="navbar-zone navbar-zone-center">
      <GlobalSmartSearch v-if="isLogged" />
    </div>

    <div class="navbar-zone navbar-zone-right" v-if="isLogged">
      <button
        class="icon-btn"
        @click="toggleTheme"
        v-b-tooltip.hover.bottom="isDarkMode ? 'Modo Claro' : 'Modo Escuro'"
      >
        <feather-icon :icon="isDarkMode ? 'SunIcon' : 'MoonIcon'" size="16" />
      </button>
      <button
        class="icon-btn"
        v-b-modal.modal-center-info-pedido
        v-b-tooltip.hover.bottom="'Modal Info. Pedido'"
      >
        <feather-icon icon="SettingsIcon" size="16" />
      </button>

      <b-nav-item-dropdown
        right
        toggle-class="user-dropdown-toggle"
        class="user-dropdown"
        no-caret
      >
        <template #button-content>
          <div class="user-avatar">
            <feather-icon icon="UserIcon" size="14" />
          </div>
          <div class="user-info d-none d-md-flex">
            <span class="user-name">{{ userData.nome ? userData.nome : userData.userData.nome }}</span>
            <span class="user-email">{{ userData.email ? userData.email : userData.userData.email }}</span>
          </div>
          <feather-icon icon="ChevronDownIcon" size="12" class="dropdown-arrow d-none d-sm-block" />
        </template>
        <b-dropdown-item link-class="d-flex align-items-center profile-item" @click="openProfileModal">
          <feather-icon size="14" icon="UserIcon" class="mr-50" />
          <span>Meu Perfil</span>
        </b-dropdown-item>
        <b-dropdown-divider />
        <b-dropdown-item link-class="d-flex align-items-center logout-item" @click="logout()">
          <feather-icon size="14" icon="LogOutIcon" class="mr-50" />
          <span>Sair</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>

      <div class="icon-btn-wrapper cart-wrapper" id="cartBtn">
        <cart-dropdown />
      </div>
    </div>

    <representante-profile-modal ref="profileModal" />

    <div v-if="!isLogged" class="navbar-zone navbar-zone-right">
      <button
        class="icon-btn"
        @click="toggleTheme"
        v-b-tooltip.hover.bottom="isDarkMode ? 'Modo Claro' : 'Modo Escuro'"
      >
        <feather-icon :icon="isDarkMode ? 'SunIcon' : 'MoonIcon'" size="16" />
      </button>

      <b-link :to="{ name: 'login'}" class="login-btn">
        <feather-icon icon="LogInIcon" size="14" class="mr-50" />
        Entrar
      </b-link>
    </div>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar, VBTooltip, VBModal,
} from 'bootstrap-vue';
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue';
import useJwt from '@/auth/jwt/useJwt';
import { initialAbility } from '@/libs/acl/config';
import LogoApp from '@/components/LogoApp.vue';
import CartDropdown from '@core/layouts/components/app-navbar/components/CartDropdown.vue';
import GlobalSmartSearch from '@/components/GlobalSmartSearch.vue';
import RepresentanteProfileModal from '@/components/modal/RepresentanteProfileModal.vue';

export default {
  components: {
    CartDropdown,
    LogoApp,
    GlobalSmartSearch,
    RepresentanteProfileModal,
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    DarkToggler,
  },
  directives: {
    'b-tooltip': VBTooltip,
    'b-modal': VBModal,
  },
  data() {
    return {
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND,
    };
  },
  computed: {
    userData() {
      return JSON.parse(localStorage.getItem('userData'));
    },
    isLogged() {
      return localStorage.getItem('userData') && localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName);
    },
    isMenuCollapsed() {
      return this.$store.state.verticalMenu.isVerticalMenuCollapsed;
    },
    isDarkMode() {
      return this.$store.state.appConfig.layout.skin === 'dark';
    },
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    openProfileModal() {
      this.$refs.profileModal.openModal();
    },
    toggleMenuCollapsed() {
      this.$store.commit('verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED', !this.isMenuCollapsed);
    },
    toggleTheme() {
      const newSkin = this.isDarkMode ? 'light' : 'dark';
      this.$store.commit('appConfig/UPDATE_SKIN', newSkin);
      localStorage.setItem('vuexy-skin', newSkin);
      document.documentElement.setAttribute('data-theme', newSkin);
    },
    logout() {
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName);
      localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName);
      localStorage.removeItem('userData');
      localStorage.removeItem('userPermissions');
      localStorage.removeItem('lgn_admin');
      localStorage.removeItem('lgn_admin_metadata');
      localStorage.removeItem('estado');
      this.$store.dispatch('cart/clearCart');
      this.$store.dispatch('PedidosStore/clearPedidoAndItemPedido');
      this.$ability.update(initialAbility);
      this.$router.push({ name: 'login' });
    },
  },
};
</script>

<style lang="scss">
.navbar-container-b2b {
  width: 100%;
  padding: 0 1rem;
  gap: 0.75rem;
  min-height: 48px;

  .navbar-zone {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .navbar-zone-left {
    flex-shrink: 0;
  }

  .navbar-zone-center {
    flex: 1;
    display: flex;
    justify-content: center;
    max-width: 600px;
    margin: 0 auto;
  }

  .navbar-zone-right {
    flex-shrink: 0;
    gap: 0.375rem;
  }

  .menu-toggle-btn,
  .menu-collapse-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
    background: var(--header-control-bg);
    border: 1px solid var(--header-control-border);
    border-radius: 6px;
    transition: all 0.2s ease;

    svg {
      color: var(--header-control-icon);
    }

    &:hover {
      background: var(--header-control-hover-bg);
      border-color: var(--header-control-hover-border);

      svg {
        color: var(--header-control-icon-hover);
      }
    }
  }

  .icon-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
    background: var(--header-control-bg);
    border: 1px solid var(--header-control-border);
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;

    svg {
      color: var(--header-control-icon);
    }

    &:hover {
      background: var(--header-control-hover-bg);
      border-color: var(--header-control-hover-border);

      svg {
        color: var(--header-control-icon-hover);
      }
    }
  }

  .icon-btn-wrapper {
    .nav-link,
    .dropdown-cart {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      padding: 0;
      background: var(--header-control-bg);
      border: 1px solid var(--header-control-border);
      border-radius: 6px;
      transition: all 0.2s ease;

      svg {
        color: var(--header-control-icon);
      }

      &:hover {
        background: var(--header-control-hover-bg);
        border-color: var(--header-control-hover-border);

        svg {
          color: var(--header-control-icon-hover);
        }
      }
    }

    &.cart-wrapper .badge {
      position: absolute;
      top: -6px;
      right: -6px;
      background: #dc2626;
      color: #fff;
      font-size: 0.625rem;
      font-weight: 600;
      min-width: 16px;
      height: 16px;
      padding: 0 4px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 2px solid var(--header-bg);
    }
  }

  .user-dropdown {
    list-style: none;
      &::marker {
        content: '';
      }
    .user-dropdown-toggle {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      padding: 0.25rem 0.5rem 0.25rem 0.25rem;
      background: var(--header-user-bg);
      border: 1px solid var(--header-user-border);
      border-radius: 6px;
      transition: all 0.2s ease;

      &:hover {
        background: var(--header-user-hover-bg);
        border-color: var(--header-control-hover-border);
      }

      &::after {
        display: none;
      }
    }

    .user-avatar {
      width: 28px;
      height: 28px;
      background: linear-gradient(135deg, #6366f1, #8b5cf6);
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;

      svg {
        color: #fff;
      }
    }

    .user-info {
      flex-direction: column;
      text-align: left;
      line-height: 1.2;
      max-width: 140px;
    }

    .user-name {
      font-size: 0.8125rem;
      font-weight: 600;
      color: var(--header-user-text);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .user-email {
      font-size: 0.6875rem;
      color: var(--header-user-text-muted);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .dropdown-arrow {
      color: var(--header-user-text-muted);
      margin-left: 0.25rem;
      transition: transform 0.2s ease;
    }

    &.show .dropdown-arrow {
      transform: rotate(180deg);
    }

    .dropdown-menu {
      background: var(--dropdown-bg);
      border: 1px solid var(--dropdown-border);
      border-radius: 8px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
      padding: 0.375rem;
      min-width: 160px;
      margin-top: 0.25rem;

      .dropdown-item {
        font-size: 0.8125rem;
        color: var(--dropdown-text);
        padding: 0.5rem 0.75rem;
        border-radius: 6px;
        transition: all 0.15s ease;

        svg {
          color: var(--text-muted);
        }

        &:hover {
          background: var(--dropdown-hover);
        }
      }

      .profile-item:hover,
      .settings-item:hover {
        background: var(--dropdown-hover);
      }

      .logout-item:hover {
        background: rgba(220, 38, 38, 0.1);
        color: #dc2626;

        svg {
          color: #dc2626;
        }
      }

      .dropdown-divider {
        margin: 0.25rem 0.5rem;
        border-color: var(--border-color, #e5e7eb);
      }
    }
  }

  .login-btn {
    display: flex;
    align-items: center;
    gap: 0.375rem;
    padding: 0.375rem 0.75rem;
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
    color: #fff;
    border-radius: 6px;
    font-weight: 600;
    font-size: 0.8125rem;
    transition: all 0.2s ease;

    svg {
      color: #fff;
    }

    &:hover {
      opacity: 0.9;
      color: #fff;
    }
  }
}

.header-navbar {
  background: var(--header-bg);
  border-bottom: 1px solid var(--header-border);
  box-shadow: var(--header-shadow);
  min-height: 48px;

  .navbar-container {
    padding: 0;
  }
}

body:not(.dark-layout) {
  --header-bg: #f8fafc;
  --header-border: #e2e8f0;
  --header-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  --header-control-bg: #ffffff;
  --header-control-border: #e2e8f0;
  --header-control-hover-bg: #f1f5f9;
  --header-control-hover-border: #cbd5e1;
  --header-control-icon: #64748b;
  --header-control-icon-hover: #334155;
  --header-user-bg: #ffffff;
  --header-user-border: #e2e8f0;
  --header-user-hover-bg: #f1f5f9;
  --header-user-text: #1e293b;
  --header-user-text-muted: #64748b;
  --header-input-bg: #ffffff;
  --header-text-primary: #1e293b;
  --dropdown-bg: #ffffff;
  --dropdown-border: #e2e8f0;
  --dropdown-text: #334155;
  --dropdown-hover: #f1f5f9;
}

body.dark-layout {
  --header-bg: #1e293b;
  --header-border: #334155;
  --header-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  --header-control-bg: #334155;
  --header-control-border: #475569;
  --header-control-hover-bg: #475569;
  --header-control-hover-border: #64748b;
  --header-control-icon: #94a3b8;
  --header-control-icon-hover: #e2e8f0;
  --header-user-bg: #334155;
  --header-user-border: #475569;
  --header-user-hover-bg: #475569;
  --header-user-text: #f1f5f9;
  --header-user-text-muted: #94a3b8;
  --header-input-bg: #334155;
  --header-text-primary: #f1f5f9;
  --dropdown-bg: #1e293b;
  --dropdown-border: #334155;
  --dropdown-text: #e2e8f0;
  --dropdown-hover: #334155;
}
</style>
